/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
import React, {
  useEffect, useContext, useMemo, useRef
} from 'react'
import { useLocation, useHistory } from 'react-router'
import cookie from 'react-cookies'
import TransactionSummarySection from '@apps/flows/activation/sections/TransactionSummarySection'
import { getPromoNames } from '@apps/utils/common'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { useSelector } from 'react-redux'
import Sites from '@sites/index'
import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import DealerActivationPaths from '@sites/dealer/activation/DealerActivationPaths'

const TransactionSummaryPage = () => {
  const {
    userType,
    content: { featureFlags },
    user: {
      accountInfo
    },
    quote: {
      quoteInfo
    }
  } = useSelector((state) => state.common)

  const { plan } = useSelector((state) => state.plansPage)
  const { ban } = useSelector((state) => state.accountSetupPage)
  const { simType } = useSelector((state) => state.simSelectionPage.selectSimType || {})
  const { cityName } = useSelector((state) => state.phoneNumberPage)
  const { multiPromotionCodeInfo } = useSelector((state) => state.payAndReviewPage)

  const UUID = 'uuid'
  const uuid = cookie.load(UUID) || null

  const journeyType = quoteInfo?.SimInformation?.simType || simType


  const pageRef = useRef(null)
  useEffect(() => {
    window.scrollTo(0, 0)

    if (pageRef.current) {
      pageRef.current.style.minHeight = '100vh'
    }
  }, [])

  const isDealer = useMemo(() => {
    return userType === Sites.dealer
  }, [userType])

  const history = useHistory()
  const consumerActivationPaths = new ConsumerActivationPaths()
  const dealerActivationPaths = new DealerActivationPaths()

  const splashPage = featureFlags && featureFlags[0]?.showSplashing
  if (splashPage) {
    if (isDealer) history.push(dealerActivationPaths.Splash)
    else history.push(consumerActivationPaths.Splash)
  }

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === 'pop' || action === 'POP') {
        return false
      }

      return () => {
        unblock()
      }
    })
  }, [history])

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.IDENTITY]: identity
  } = useContext(ApplicationContext)

  const location = useLocation()

  const tagManagerInfo = {
    plan_name: plan?.sluggedName || 'NA',
    plan_cost: plan?.value || 'NA',
    customer_ban: ban || 'NA',
    customer_quote_id: accountInfo?.quoteId || quoteInfo?.quoteId || 'NA',
    dealer_info: userType === Sites.dealer ? identity : 'NA',
    journey_type: journeyType,
    city: cityName,
    uuid: uuid
  }

  const pushTagManagerToDataLayer = () => {
    const event_type = 'Activation Successfull'
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'form', region, language, {
        ...tagManagerInfo,
        promoCodeDescription: getPromoNames([plan?.promo, ...multiPromotionCodeInfo])
      }, event_type)
    )
  }

  useEffect(() => {
    if (userType === Sites.dealer && identity) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language, identity])

  useEffect(() => {
    if (userType === Sites.consumer) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language])

  return (
    <div className="flex flex-col max-w-6xl pb-12 m-auto space-y-4 lg:space-y-24">
      <TransactionSummarySection />
    </div>
  )
}

export default TransactionSummaryPage
